// Types

export type MainStoreGMapsErrorState = {
  errored: boolean;
};

export type SetGMapsErrorAction = {
  type: 'SET_GMAPS_ERROR';
};

export type MainStoreGMapsErrorAction = SetGMapsErrorAction;

// Reducer

const initialState = {
  errored: false,
};

export function gMapsErrorReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreGMapsErrorState = initialState,
  action: MainStoreGMapsErrorAction,
) {
  switch (action.type) {
    case 'SET_GMAPS_ERROR':
      return {
        errored: true,
      };

    default:
      return state;
  }
}
